function isToday (date) {
  const dateMidnight = new Date(date.getTime())
  dateMidnight.setHours(0, 0, 0, 0)
  const todayMidnight = new Date(window.today.getTime())
  return dateMidnight.getTime() === todayMidnight.getTime()
}

function isTomorrow (date) {
  const dateMidnight = new Date(date.getTime())
  dateMidnight.setHours(0, 0, 0, 0)
  const tomorrowMidnight = new Date(window.today.getTime())
  tomorrowMidnight.setDate(window.today.getDate() + 1)
  return dateMidnight.getTime() === tomorrowMidnight.getTime()
}

function formatPrice(priceStr) {
  return priceStr.replace(/,/g, '.')
}

function removeKeyProp(obj) {
  const objClone = { ...obj }
  delete objClone['.key']
  return objClone
}

function arrayToMap(array, idProp) {
  return array.reduce((acc, item) => {
    return { ...acc, [item[idProp]]: item }
  }, {})
}

export {
  isToday,
  isTomorrow,
  formatPrice,
  removeKeyProp,
  arrayToMap,
}



// WEBPACK FOOTER //
// ./src/utils/index.js